/**
 * Homepage Header Scroll Behavior
 * - Hides logo initially on homepage
 * - Shows logo and adds background color when scrolled full viewport height
 */

(function() {
  // Wait for DOM to be fully loaded
  function init() {
    // Only run on homepage (check if path is root)
    const isHomepage = window.location.pathname === '/' || window.location.pathname === '/index';

    if (!isHomepage) return;

    const header = document.querySelector('.site-header');

    // Try multiple selectors to find the logo
    let logoContainer = document.querySelector('.site-header h1');
    if (!logoContainer) logoContainer = document.querySelector('.site-header .h1');
    if (!logoContainer) logoContainer = document.querySelector('.site-header__logo-link');

    if (!header || !logoContainer) return;

    // Debounce function to improve scroll performance
    function debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }

    // Get scroll threshold (full viewport height for desktop, 50% for mobile/tablet)
    function getScrollThreshold() {
      const isMobile = window.innerWidth < 990;
      return isMobile ? window.innerHeight * 0.5 : window.innerHeight;
    }

    // Initially hide the logo on homepage
    logoContainer.style.opacity = '0';
    logoContainer.style.transition = 'opacity 0.3s ease-in-out';
    logoContainer.style.visibility = 'hidden';

    // Add transition to header for smooth background change
    if (!header.style.transition || header.style.transition === '') {
      header.style.transition = 'background-color 0.3s ease-in-out';
    }

    // Handle scroll events
    function handleScroll() {
      const scrollPosition = window.scrollY;
      const threshold = getScrollThreshold();

      if (scrollPosition >= threshold) {
        // Scrolled past threshold - show logo and add background
        logoContainer.style.opacity = '1';
        logoContainer.style.visibility = 'visible';
        header.style.setProperty('background-color', '#C5B391', 'important');
      } else {
        // Above threshold - hide logo and keep transparent
        logoContainer.style.opacity = '0';
        logoContainer.style.visibility = 'hidden';
        header.style.removeProperty('background-color');
      }
    }

    // Attach scroll listener with debouncing
    window.addEventListener('scroll', debounce(handleScroll, 10));

    // Also handle on resize (in case viewport height changes)
    window.addEventListener('resize', debounce(handleScroll, 100));

    // Run once on load
    handleScroll();
  }

  // Run init when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
